module.exports = __webpack_public_path__ + "static/media/divide.c2137155.svg";